import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceListModalComponent } from './device-list-modal/device-list-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceDetailsModalComponent } from '../device-details-modal/device-details-modal.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [DeviceListModalComponent, DeviceDetailsModalComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatRowComponent, MaterialModule],
  exports: [DeviceListModalComponent, DeviceDetailsModalComponent],
})
export class DeviceListModalModule {}
